import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  imports: [CommonModule, FaIconComponent],
})
export class LoadingOverlayComponent {
  text = input('Daten werden geladen...');
  icon = input<IconProp>(['far', 'cogs']);
  fullScreen = input(true);
}
